function includeHtml(): void {
    //
    const includes = document.getElementsByTagName('include');
    //
    if (!includes.length) {
        return;
    }

    //
    const loadFile = async function (filename: string, callback: any): Promise<undefined> {
        await fetch(filename)
            .then(async (response): Promise<any> => response.text())
            .then((text): any => callback(text));
    };

    //
    for (const include of includes) {
        const filename = include.getAttribute('src');

        if (filename == null) {
            continue;
        }

        void loadFile(filename, function (text: string): any {
            /* include.innerHTML = text; */
            include.insertAdjacentHTML('afterend', text);
            include.remove();
        });
    }
}

// ----------------------------------------------------------------------------

function includeStyle(url: string, config: Record<string, any> = {}): void {
    // Create element (style)
    const elStyle = document.createElement('link');
    elStyle.href = url;
    elStyle.rel = 'stylesheet';
    elStyle.type = 'text/css';

    // If using function load
    if (typeof config.fnLoad === 'function') {
        elStyle.onload = function (evt): void {
            config.fnLoad.call(this, evt);
        };
    }

    // If using function error
    if (typeof config.fnError === 'function') {
        elStyle.onerror = function (evt): void {
            config.fnError.call(this, evt);
        };
    }

    //
    document.head.appendChild(elStyle);
}

function includeStyles(urls: string[], config: Record<string, any> = {}): void {
    for (const url of urls) {
        includeStyle(url, config);
    }
}

// ----------------------------------------------------------------------------

function includeScript(url: string, config: Record<string, any> = {}): void {
    // Create element (script)
    const elScript = document.createElement('script');
    elScript.src = url;
    elScript.type = 'text/javascript';

    // If using function load
    if (typeof config.fnLoad === 'function') {
        elScript.onload = function (evt): void {
            config.fnLoad.call(this, evt);
        };
    }

    // If using function error
    if (typeof config.fnError === 'function') {
        elScript.onerror = function (evt): void {
            config.fnError.call(this, evt);
        };
    }

    //
    document.body.appendChild(elScript);
}

function includeScripts(urls: string[], config: Record<string, any> = {}): void {
    for (const url of urls) {
        includeScript(url, config);
    }
}

// ----------------------------------------------------------------------------

export {
    includeHtml as html,
    includeStyle as style,
    includeStyles as styles,
    includeScript as script,
    includeScripts as scripts,
};
